import { useContext, useState } from 'react'
import { SalonReviewsResponse } from '../types/types'
import { AppContext } from '../utils/appProvider'

type FetchMoreReviewsResult = {
	success: boolean
	loadedCount: number
}

const useSalonReviews = (salonId: string, reviewsData: SalonReviewsResponse | undefined) => {
	const { apiBrowser } = useContext(AppContext)

	const initialReviews = reviewsData?.reviews && reviewsData?.reviews.length > 0 ? reviewsData?.reviews : null
	const [reviews, setReviews] = useState(initialReviews)
	const [reviewsPage, setReviewsPage] = useState(1)
	const [isLoadingReviews, setIsLoadingReviews] = useState(false)

	const fetchMoreReviews = async (args: { resetPage?: boolean } = {}): Promise<FetchMoreReviewsResult> => {
		const { resetPage = false } = args
		const pageToFetch = resetPage ? 1 : reviewsPage + 1

		setIsLoadingReviews(true)

		try {
			const newReviewsData = await apiBrowser.b2c.getSalonReviewsData(salonId, { page: pageToFetch })

			if (newReviewsData) {
				setReviews((prev) => {
					if (prev && !resetPage) return [...prev, ...newReviewsData.reviews]
					return newReviewsData.reviews
				})
				setReviewsPage(pageToFetch)

				return { success: true, loadedCount: newReviewsData.reviews.length }
			}

			return { success: false, loadedCount: 0 }
		} catch {
			return { success: false, loadedCount: 0 }
		} finally {
			setIsLoadingReviews(false)
		}
	}

	return { reviews, reviewsPage, isLoadingReviews, fetchMoreReviews }
}

export default useSalonReviews
